import { h } from 'preact';
import { LevelProgressBar } from '../LevelProgressBar';
import type { Level } from '../LevelProgressBar';
import type { ComponentShowcase } from '../registry';
import { T } from '../../../styles/tokens';

const DEMO_LEVELS: Level[] = [
  { name: 'bronze', label: 'Bronze', icon: '🥉', color: '#cd7f32', min: 0 },
  { name: 'silver', label: 'Prata', icon: '🥈', color: T.textSecondary, min: 5 },
  { name: 'gold', label: 'Ouro', icon: '🥇', color: '#ffd700', min: 15 },
  { name: 'diamond', label: 'Diamante', icon: '💎', color: '#00d4ff', min: 50 },
];

function LevelProgressBarDemo() {
  return (
    <div style={{ maxWidth: 400 }}>
      <LevelProgressBar
        levels={DEMO_LEVELS}
        currentLevel={DEMO_LEVELS[1]!}
        nextLevel={DEMO_LEVELS[2] ?? null}
        progress={60}
      />
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'LevelProgressBar',
  category: '📋 Cards & Layout',
  description: 'Barra de progresso de nível com milestones e indicadores',
  usedIn: ['ReferralDashboard'],
  example: LevelProgressBarDemo,
};
